import React, { useState } from "react";
import BidAnalyzer from "./substeps/RealTimeBidAnalyzer";

interface StepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formData: {
    bid: string;
    [key: string]: string;
  };
}

const BidStep: React.FC<StepProps> = ({ handleInputChange, formData }) => {
  const [bid, setBid] = useState<number>(parseFloat(formData.bid) || 0.001);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  // Handle bid change and update parent formData
  const handleBidChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newBid = parseFloat(e.target.value) || 0;
    setBid(newBid);

    // Create a synthetic event to pass the updated value to the parent
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        name: "bid", // Ensure the name matches the formData key
        value: e.target.value,
      },
    };
    handleInputChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        maxWidth: "100%",
        margin: "0 10px",
        float: "left",
      }}
    >
      {/* Header Text */}
      <p style={{ fontSize: "14px", marginBottom: "10px" }}>
        Set the cost per visitor (CPV) bid for your campaign. Your bid will
        determine the exposure of your ad. Increasing your bid will improve your
        ad's exposure.
      </p>
      <p style={{ fontSize: "14px", marginBottom: "20px" }}>
        Real time bid Analyzer - Get current top bid based on your campaign's
        targeting
      </p>
      <p style={{ fontSize: "14px", marginBottom: "20px" }}>
        Click "Next" to continue.
      </p>

      {/* Bid Input Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          border: "1px solid #ccc",
          backgroundColor: "#f9f9f9",
          width: "100%",
        }}
      >
        {/* Your Bid Input */}
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <label
            htmlFor="yourBid"
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Your Bid: $
          </label>
          <input
            id="yourBid"
            name="bid" // Name must match formData key
            type="number"
            // step="0.0001"
            // min="0.001"
            value={formData.bid}
            onChange={handleBidChange}
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "10px",
              margin: "0px",
              fontSize: "14px",
              flex: 1,
              maxWidth: "100px",
            }}
          />
        </div>

        {/* Effective Bid */}
        <div
          style={{
            flex: 1,
            textAlign: "center",
            width: "100px",
            border: "solid",
            borderWidth: "0px 0px 0px 1px",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: "bold" }}>
            Effective Bid:
          </span>
          <span style={{ marginLeft: "5px", fontSize: "14px", color: "#555" }}>
            ${(bid * 1.019).toFixed(4)}
          </span>
          <i
            className="fa fa-info-circle"
            style={{ fontSize: "14px", marginLeft: "4px" }}
          ></i>
        </div>

        {/* Bid Range */}
        <div
          style={{
            flex: 1,
            textAlign: "center",
            border: "solid",
            borderWidth: "0px 0px 0px 1px",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: "bold" }}>
            Bid Range:
          </span>
          <span style={{ marginLeft: "5px", fontSize: "14px", color: "#555" }}>
            $0.0010 - $3
          </span>
        </div>

        {/* Real-time Bid Analyzer */}
        <div
          style={{
            flex: 1,
            textAlign: "right",
            border: "solid",
            borderWidth: "0px 0px 0px 1px",
          }}
        >
          <a
          
            style={{ fontSize: "14px", color: "#007bff", textDecoration: "none" }}
            onClick={(e) => {
              e.preventDefault();
              openPopup();
            }}
          >
            Real time Bid Analyzer
          </a>
        </div>
      </div>

      {/* Popup Component */}
      {isPopupOpen && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000000,
            padding: "0px",
            backdropFilter: "blur(5px)", // Applies the blur effect to the background
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "0px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
              width: "720px",
              height: "80%",
              position: "relative",
            }}
          >
            <button
              onClick={closePopup}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "transparent",
                border: "none",
                fontSize: "24px",
                color: "#000",
                cursor: "pointer",
                padding: "0",
              }}
            >
              &times;
            </button>
            <div
              style={{
                backgroundColor: "#1B3A5E",
                width: "100%",
                height: "50px",
                color: "white",
                display: "flex",
                alignItems: "center", // Vertically centers the text
                justifyContent: "flex-start",
                fontSize: "16px", // Aligns the text to the left
                paddingLeft: "20px", // Adds some space from the left edge
              }}
            >
              Real time Bid Analyzer
            </div>

            <BidAnalyzer />

            {/* Content of your popup */}
          </div>
        </div>
      )}
    </div>
  );
};

export default BidStep;
